export const TextConstants = {
  COPY_TO_CLIPBOARD_DEFAULT_HOVER_TEXT: 'Copy to clipboard',
  COPY_TO_CLIPBOARD_DEFAULT_COPIED_TEXT: 'Copied',
}
